import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../hooks/redux-hooks";
import { updateGameStage, fetchGameStage } from "../slices/authSlice";
import { useNavigate } from "react-router-dom";
import "./PinBoard.css";

export const PinBoard = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const gameStage = useAppSelector((state) => state.auth.basicUserInfo?.gameStage ?? 0);

    useEffect(() => {
        dispatch(fetchGameStage());
    }, [dispatch]);

    const handleNext = async () => {
        if (gameStage === 0) {
            await dispatch(updateGameStage(1));
            navigate("/mentalstate");
        } else if (gameStage === 1) {
            await dispatch(updateGameStage(2));
            navigate("/rulechaining");
        } else if (gameStage === 2) {
            await dispatch(updateGameStage(0));
            navigate("/gamehub");
        }
    };

    return (
        <div className="pinboard-background">
            {/* Show crosses based on stage */}
            {gameStage >= 1 && (
                <img
                    src="/pinboard/Cross.png"
                    className="stageOne-cross"
                    alt="Cross on Lisa"
                />
            )}
            {gameStage >= 2 && (
                <img
                    src="/pinboard/Cross.png"
                    className="stageTwo-cross"
                    alt="Cross on Jonas"
                />
            )}

            {(gameStage === 0 || gameStage === 1) && (
                <button className="big-blue-button" onClick={handleNext}>
                    Weiter geht's!
                </button>
            )}

            {gameStage === 2 && (
                <button className="big-green-button" onClick={handleNext}>
                    Gute Arbeit! Danke!
                </button>
            )}
        </div>
    );
};

export default PinBoard;
